import React, { useState, useEffect } from "react";
import rtfToHTML from "@iarna/rtf-to-html";

export function hasTextContent(value) {
  return value != null && String(value).trim().length > 0;
}

function isRtfContent(content) {
  return typeof content === "string" && /^\{\\rtf/i.test(content.trim());
}

function isHtmlContent(content) {
  return typeof content === "string" && /<[a-z][\s\S]*>/i.test(content.trim());
}

function extractBodyHtml(fullHtml) {
  const match = fullHtml.match(/<body[^>]*>([\s\S]*)<\/body>/i);
  return match ? match[1].trim() : fullHtml;
}

function plainTextToHtml(text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br />");
}

function prepareRichTextHtml(content) {
  const trimmed = String(content).trim();
  if (!trimmed) {
    return Promise.resolve("");
  }
  if (isRtfContent(trimmed)) {
    return new Promise((resolve) => {
      rtfToHTML.fromString(trimmed, (err, result) => {
        if (err) {
          resolve(plainTextToHtml(trimmed));
          return;
        }
        resolve(extractBodyHtml(result));
      });
    });
  }
  if (isHtmlContent(trimmed)) {
    return Promise.resolve(trimmed);
  }
  return Promise.resolve(plainTextToHtml(trimmed));
}

const RichTextContent = ({ content, className, style }) => {
  const [html, setHtml] = useState("");

  useEffect(() => {
    let cancelled = false;

    prepareRichTextHtml(content).then((result) => {
      if (!cancelled) {
        setHtml(result);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [content]);

  if (!html) {
    return null;
  }

  return (
    <div
      className={`rich-text-content ${className || ""}`.trim()}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichTextContent;
